module.exports = __webpack_public_path__ + "static/scale-model-of-worcester-art-museum-in-worcester-massachusetts-3d0239c68df9b8391feb55aaa82cfae8.png";